import AppStoreContext from 'contexts/AppStoreContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import Markup from 'editor/components/Markup';
import React, { FC, useContext, useEffect } from 'react';
import { ViewRFI } from 'records/interactions/ViewRFI';

type Props = {
  interaction: ViewRFI;
};

const ManageViewRFIInteraction: FC<Props> = ({ interaction }) => {
  const world = useContext(ECSWorldContext);

  useEffect(() => {
    world.grabAll(Markup).forEach(({ component }) => {
      if (component.markup.markupid === interaction.markup?.markupid) {
        component.selected = true;
      }
    });

    return () => {
      world.grabAll(Markup).forEach(({ component }) => {
        if (component.markup.markupid === interaction.markup?.markupid) {
          component.selected = false;
        }
      });
    };
  }, [interaction.markup?.markupid]);

  return null;
};

const ManageViewRFIInteractionWrapper: FC = () => {
  const { state: appState } = useContext(AppStoreContext);
  const viewRfiInteractions = appState.getInteractions('ViewRFI');

  if (viewRfiInteractions.size === 1) {
    return (
      <ManageViewRFIInteraction
        interaction={viewRfiInteractions.get(0, new ViewRFI())}
      />
    );
  }

  return null;
};

export default ManageViewRFIInteractionWrapper;
